import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// CAREPLAN_CHANGE_STATUS

const mutation = gql`
  mutation roadmapChangeStatus($id: ID!, $with: ROADMAP_CHANGE_STATUS_EVENT!) {
    roadmapChangeStatus(id: $id, with: $with) {
      id
      state
    }
  }
`
export default function useRoadmapChangeStatus(
  successMessage = 'Status updated'
) {
  const { onMutate: onRoadmapChangeStatus, loading } = useSafeRunMutation({
    mutation,
    successMessage,
    responsePath: 'roadmapChangeStatus'
  })
  return { onRoadmapChangeStatus, loading }
}
